import styled, { css } from 'styled-components/macro';
import { colorCoreGray500, colorBlackTransparent50, colorCoreBlack900Base, colorCoreGray100, colorCoreGray800, defaultTransparent, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { FlexWrapper } from '@yme/tokens/flexTokens';
import { ADAPTIVE } from '@yme/tokens/screen';
import { RegularTextLevel4 } from '@yme/tokens/typography';
export const FlexWrapperStyled = styled(FlexWrapper) `
  max-width: 350px;
  margin-left: auto;
  margin-right: auto;

  ${ADAPTIVE.minWidth.tablet} {
    max-width: initial;
    margin-left: initial;
    margin-right: initial;
  }
`;
export const PaginationStyled = styled.ul `
  position: relative;
  display: flex;
  padding: 0px;
  list-style: none;
  margin: 0;
  width: 100%;

  ${ADAPTIVE.minWidth.tablet} {
    width: auto;
  }

  ${({ isRightToLeft }) => isRightToLeft &&
    css `
      direction: rtl;

      /* TODO: (D.K.) Need clarify in the future - about 'inverted' Arrow Icon, */
      /* from AC this Icons shouldn't invert but from material.ui doc it should be */
      /* inverted (with option -> isRightToLeft=true) */
      li {
        svg {
          transform: rotate(180deg);
        }
      }
    `};
`;
const HoverStyles = css `
  background-color: ${colorBlackTransparent50};
  border: 1px solid ${colorCoreBlack900Base};
`;
const DefaultStyles = css `
  background-color: ${defaultTransparent};
  border: 1px solid ${defaultTransparent};
`;
// Style for text
export const PaginationInnerStyled = styled(RegularTextLevel4) `
  color: ${colorCoreBlack900Base};

  font-weight: 500;
  display: flex;
  align-items: center;
  justify-content: center;
  user-select: none;
`;
// Common style for each item pagination elements
const PaginationItemStyles = styled.li `
  display: flex;
  align-items: center;
  justify-content: center;
  box-sizing: border-box;
  margin: 0 3px;
  padding: 0px;

  border: 1px solid ${colorCoreGray500};
  border-radius: ${CORNER_RADIUS.s};

  width: 44px;
  height: 44px;
`;
// State=Default (with Active state)
export const PaginationDefaultItemStyled = styled(PaginationItemStyles) `
  transition: background-color 150ms, border 150ms cubic-bezier(0.39, 0.58, 0.57, 1) 150ms;

  &:hover {
    ${HoverStyles};

    cursor: pointer;
  }

  /* State=Clicked / Active */
  ${({ isActive }) => isActive &&
    css `
      background-color: ${colorCoreBlack900Base};
      border: 1px solid ${colorCoreBlack900Base};

      & > span {
        color: ${colorCoreGray100};

        svg {
          path {
            stroke: ${colorCoreGray100};
          }
        }
      }

      &:hover {
        background-color: ${colorCoreBlack900Base};
        border: 1px solid ${colorCoreBlack900Base};

        & > span {
          color: ${colorCoreGray100};

          svg {
            path {
              stroke: ${colorCoreGray100};
            }
          }
        }
      }
    `}
`;
// State=Empty (Reset styles for border and background)
export const PaginationEmptyItemStyled = styled(PaginationItemStyles) `
  ${DefaultStyles};

  &:hover {
    ${DefaultStyles};
  }
`;
// Styles for arrows of pagination (with disabled state)
export const PaginationArrowsItemStyled = styled(PaginationItemStyles) `
  transition: background-color 150ms, border 150ms cubic-bezier(0.39, 0.58, 0.57, 1) 150ms;

  &:hover {
    ${HoverStyles};

    cursor: pointer;
  }

  ${({ isDisabled }) => isDisabled &&
    css `
      background-color: ${colorBlackTransparent50};
      border: 1px solid ${colorCoreGray500};

      &:hover {
        border: 1px solid ${colorCoreGray500};

        /* TODO: (D.K.) This is style with option='not-allowed;' for cursor not approved from Design Team */
        cursor: auto;
      }

      & > span {
        color: ${colorCoreGray800};

        svg {
          path {
            stroke: ${colorCoreGray800};
          }
        }
      }
    `};

  ${ADAPTIVE.maxWidth.mobile} {
    &:first-child {
      margin-right: ${({ isRightToLeft }) => (isRightToLeft ? '0' : 'auto')};
      margin-left: ${({ isRightToLeft }) => (isRightToLeft ? 'auto' : '0')};
    }

    &:last-child {
      margin-right: ${({ isRightToLeft }) => (isRightToLeft ? 'auto' : '0')};
      margin-left: ${({ isRightToLeft }) => (isRightToLeft ? '0' : 'auto')};
    }
  }
`;
